import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import InViewObserver from 'components/InViewObserver';

const IFrame = props => {
  if (!props.dataUrl) {
    return null;
  }
  const iframeRef = useRef(null);

  const onBlur = () => {
    if (
      props.ga &&
      props.ga.type &&
      document &&
      document.activeElement &&
      document.activeElement.nodeName.toLowerCase() === 'iframe' &&
      iframeRef &&
      iframeRef.current &&
      iframeRef.current === document.activeElement
    ) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: props.ga.type,
        label: window && window?.location?.href,
      });
    }
  };

  useEffect(() => {
    window.addEventListener('blur', onBlur);
    return () => {
      window.removeEventListener('blur', onBlur);
    };
  }, []);

  const getIframeHtml = () => {
    const iframeSrc = props.dataUrl;
    return (
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        loading={props.lazy ? 'lazy' : 'eager'}
        title={props.name}
        height={props.height}
        marginWidth="0"
        marginHeight="0"
        frameBorder="0"
        scrolling="no"
        align="center"
        style={{
          width: '100%',
        }}
      />
    );
  };

  return (
    <InViewObserver
      inViewCallback={() => {
        if (props.ga && props.ga.type) {
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: props.ga.type,
            label: window && window?.location?.href,
          });
        }
      }}
    >
      <div
        className={classNames({
          [props.className]: true,
        })}
      >
        {getIframeHtml()}
      </div>
    </InViewObserver>
  );
};

IFrame.propTypes = {
  name: PropTypes.string,
  dataUrl: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.string.isRequired,
  lazy: PropTypes.bool,
  ga: PropTypes.shape({}),
};

IFrame.defaultProps = {
  name: '',
  className: '',
  lazy: false,
  dataUrl: '',
  ga: undefined,
};

export default IFrame;
